import { render, staticRenderFns } from "./AcademicActivityModal.vue?vue&type=template&id=7d15916e"
import script from "./AcademicActivityModal.vue?vue&type=script&lang=js"
export * from "./AcademicActivityModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports